import React, { useState, useEffect } from 'react'
import { NavLink, useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode } from 'primereact/api';
import { download } from '../../utils/download'
import { useToast } from "../../toastHook"

export const RunAosResultComponent = () => {
    let { runId } = useParams();
    const navigate = useNavigate();
    const { display } = useToast();

    const [detail, setDetail] = useState();
    const [results, setResults] = useState();

    const [filters] = useState({

        reference: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        titre: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        client: { value: null, matchMode: FilterMatchMode.STARTS_WITH }

    });

    useEffect(() => {
        axios.get('/api/aosrunresults/detail?id=' + runId)
            .then(response => {
                setDetail(response.data)

                if (response.data.id) {
                    axios.get('/api/aosrunresults/results?id=' + runId).then(
                        response => setResults(response.data)
                    );
                }
            });
    }, [runId]);

    let result = <></>;

    const previousResult = () => {
        if (detail.previousRunId) {
            navigate('/aos/result/' + detail.previousRunId);
        }
    }

    const nextResult = () => {
        if (detail.nextRunId) {
            navigate('/aos/result/' + detail.nextRunId);
        }
    }

    let previousIcon = <></>;
    if (detail && detail.previousRunId) {
        previousIcon = <i className="pi pi-arrow-circle-left text-primary" onClick={ previousResult } ></i>
    }

    let nextIcon = <></>
    if (detail && detail.nextRunId) {
        nextIcon = <i className="pi pi-arrow-circle-right text-primary" onClick={nextResult} ></i>
    }

    const reRun = () => {

        axios.get("/api/reruncalcul?runid=" + runId)
            .then(response => { 
                if (response.status === 200) {
                    display({
                        titre: 're run ok',
                        text: 'le run va être recalculé',
                        severity: 'success'
                    });
                }
                else {
                    display({
                        titre: 're run non ok',
                        text: "le run n'a pas pu être recalculé",
                        severity: 'danger'
                    });
                }
            })
    }

    const displayWithLinkToAO = (result, text) => {
        if (text) {
            return <NavLink to={"/aos/ao/" + result.id} >{text}</NavLink>
        }
        else {
            return <NavLink to={"/aos/ao/" + result.id} >inconnu</NavLink>
        }
    }

    const titre = result => displayWithLinkToAO(result, result.titre);
    const reference = result => displayWithLinkToAO(result, result.reference);

    const isValidIcon = result => {
        if (result.isCompletlyParsed) {
            return <i className="pi pi-chevron-down text-success" style={{ color: 'green' }} ></i>
        }
        else {
            return <i className="pi pi-minus-circle text-danger" ></i>
        }
    }


    if (!detail ||  !detail.compte) {
        result = <div className="alert alert-danger">
            Le run {runId} n'existe pas en base de données. Vous avez fait une fausse manip.
            <NavLink to="/aos">Veuillez retourner à la liste des runs des aos</NavLink>
        </div>
    }
    else {
        result = <div><div className="row">
            <span className="col" >{ previousIcon }</span>
            <div className="col-10 alert alert-secondary">
                <div className="card">
                    <div className="card-header"><div className="d-flex column gap-4"><h4 className="flex-grow-1">{detail.nom}</h4>
                        <i className="pi pi-replay text-primary" onClick={() => reRun()} ></i>
                        <i className="pi pi-download text-success" onClick={() => download('/api/aosrunresults/export?id=' + runId, detail.compte + "-" + moment(detail.date).format("yyyyMMDD") + ".xlsx")} ></i></div></div>
                    <div className="card-body">
                        Compte: { detail.compte  } <br />
                        Date: {moment(detail.date).format('ll')}<br />
                        {detail.lastCalculDate ? <>Dernier calcul: {moment(detail.lastCalculDate).format('lll')} </> : <></>} 
                    </div>
                </div>

            </div>
            <span className="col" >{ nextIcon }</span>
        </div>
            <div>
                <DataTable value={results} tableStyle={{ width: '100%' }}
                    filters={filters} filterDisplay="row">
                    <Column field="titre" header="Titre" filter sortable body={titre} />
                    <Column field="reference" header="Reference" filter sortable body={reference} />
                    <Column field="client" header="Client" filter sortable  ></Column>
                    <Column field="localisation" header="Localisation" ></Column>
                    <column field="isCompletlyParsed" header="Status" sortable body={isValidIcon} />
                </DataTable>
            </div>
        </div>
    }


    return result
}